import React from 'react';
import ScrollAnimation from 'react-animate-on-scroll';

export const BoostYourRevenue = () => {
  return (
    <div className="subscribeNoctil bg-gradient">
      <div className="container">
        <div className="pt--60">
          <div className="row text-center">
            <div className="col-lg-12">
              <ScrollAnimation animateIn="fadeInUp" animateOnce={true} delay={50}>
                <h2>
                  <b>Boost your revenue, productivity and efficiency</b>
                </h2>
                <div className="mt--40">
                  <a href="mailto:sales@noctil.com" className="custom-btn">
                    Talk to us
                  </a>
                </div>
              </ScrollAnimation>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
